import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';
import updateLocale from 'dayjs/plugin/updateLocale';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/ru';

// установка всех настроек для dayjs (запускаем при старте приложения)
export const setupDayjsConfig = () => {
  dayjs.locale('ru');

  dayjs.extend(relativeTime);
  dayjs.extend(duration);
  dayjs.extend(updateLocale);
  dayjs.extend(dayOfYear);
  dayjs.extend(utc);

  dayjs.updateLocale('ru', {
    weekdaysMin: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  });
};

export const getDay = (dt?: string) => (dt ? dayjs(dt).format('DD') : '');

//возвращает полное или короткое название дня недели
export const getWeekday = (dt?: string, short?: boolean) =>
  dt ? dayjs(dt).format(short ? 'dd.' : 'dddd') : '';

export const getMonthName = (dt?: string) =>
  dt ? dayjs(dt).format('DD MMMM').split(' ')[1] : '';

export const isDatesInOneMonth = (dateStart?: string, dateEnd?: string) =>
  dateStart && dateEnd && dayjs(dateStart).month() === dayjs(dateEnd).month();

// проверяет, входят ли даты в один день
export const isDatesInOneDay = (dateStart: string, dateEnd: string) =>
  dayjs(dateStart).dayOfYear() === dayjs(dateEnd).dayOfYear();

//возвращает сокращенное имя дня недели
export const getWeekdaysMin = (dt: dayjs.Dayjs) => dt.format('dd');

export const isMoreOrLessThanCurrent = (
  dt: string,
  lessThen?: boolean
): boolean =>
  !lessThen
    ? dayjs().unix() > dayjs(dt).unix()
    : dayjs().unix() < dayjs(dt).unix();

// получает время в формате hh:mm
export const getFormattedTime = (dt: string) => dayjs(dt).format('HH:mm');

//получаем текущую дату в ISO формате
export const getCurrentByISOFormat = () => dayjs().toISOString();

//отображаем дату мероприятия в разных форматах
export const getEventFormattedDate = (dateStart: string, dateEnd: string) => {
  const monthName = getMonthName(dateStart);
  const dayStart = getDay(dateStart);
  const dayEnd = getDay(dateEnd);

  //если дата начала и дата конца приходится на один день,
  // отображаем в таком формате: 02 декабря / 15:00
  if (isDatesInOneDay(dateStart, dateEnd)) {
    return `${dayStart} ${monthName} / ${dayjs(dateStart).format('HH:mm')}`;
  }

  // если дата начала и дата конца приходится на несколько дней в рамках одного месяца,
  // отображаем в таком формате: 02 - 03 декабря
  if (isDatesInOneMonth(dateStart, dateEnd)) {
    return `${dayStart} - ${dayEnd} ${monthName}`;
  }

  // если дата начала приходится на один месяц, а дата конца - на второй,
  // отображаем в таком формате: 29.11 - 02.12
  return `${dayjs(dateStart).format('DD.MM')} - ${dayjs(dateEnd).format(
    'DD.MM'
  )}`;
};

// проверяет совершеннолетие
export const isAdult = (date: Date) => dayjs().diff(dayjs(date), 'year') >= 18;
